<template>
    <div class="template-default">
        <header class="site-header">
            <div class="wrapper">
                <div class="title">
                    <b-icon icon="justify-right" @click="toggleDeskptopMenu()" class="d-none d-xl-block"></b-icon>
                    <b-icon icon="justify-right" @click="toggleMobileMenu()" class="d-xl-none"></b-icon>
                    <a href="/store" class="d-none d-sm-block"><span>YELLOW</span>TIRE - POS</a>
                    <label class="version d-none d-sm-block">Version 1.0.0</label>
                </div>
                <div class="user">
                    <b-icon icon="person"></b-icon>
                    <span>{{ profileName }}</span>
                </div>
            </div>
        </header>

        <div class="layout-container">
            <div class="menu-sidebar d-none d-xl-block" :class="{ 'expand': isToggleDesktopMenu }">
                <menu-side-bar></menu-side-bar>
            </div>
            <div class="menu-cover d-xl-none" v-if="isShowMobileMenu"></div>
            <div class="menu-sidebar d-xl-none" :class="{ 'expand': isShowMobileMenu }">
                <menu-side-bar></menu-side-bar>
            </div>
            
            <div ref="refContentBody" class="layout-body">
                <v-offline>
                    <div class="offline-notify" slot="offline">
                        <b-icon icon="exclamation-diamond" class="icon"></b-icon> ขณะนี้อุปกรณ์ของท่านไม่ได้เชื่อมต่อกับอินเทอร์เน็ต โปรดทำการตรวจสอบการเชื่อมต่อของท่าน
                    </div>
                </v-offline>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import MenuSideBar from '@/components/layouts/MenuSideBar';
import PerfectScrollbar from 'perfect-scrollbar';

export default {
    components: { MenuSideBar },
    data() {
        return {
            perfectScrollBody: null,
            modalCounter: 0,
            isToggleDesktopMenu: true,
            isShowMobileMenu: false,
            profileName: localStorage.profileName
        }
    },
    created() {
        if (location.pathname != '/' && !localStorage.token) {
            this.$router.push('/');
        }
    },
    watch: {
        $route() {
            this.$refs.refContentBody.scrollTop = 0;
        }
    },
    mounted() {
        this.setContentScrollable(true);
        
        this.$root.$on('rootSetContentScrollable', (value) => {
            this.setContentScrollable(value);
        });

        this.$root.$on('rootSetScrollToBottom', () => {
            this.setScrollToBottom();
        });

        this.$root.$on('rootHideMobileMenu', () => {
            this.hideMobileMenu();
        });
    },
    methods: {
        toggleDeskptopMenu() {
            this.isToggleDesktopMenu = !this.isToggleDesktopMenu;
        },
        toggleMobileMenu() {
            this.isShowMobileMenu = !this.isShowMobileMenu;
        },
        hideMobileMenu() {
            this.isShowMobileMenu = false;
        },
        setContentScrollable(isScrollable) {
            if (isScrollable) {
                this.modalCounter++;
            } else {
                this.modalCounter--;
            }

            if (this.modalCounter > 0 && !this.perfectScrollBody) {
                this.perfectScrollBody = new PerfectScrollbar(this.$refs.refContentBody);
            } else if (this.modalCounter == 0 && this.perfectScrollBody) {
                this.perfectScrollBody.destroy();
                this.perfectScrollBody = null;
            }
        },
        setScrollToBottom() {
            // Reset Scroll
            this.$refs.refContentBody.scrollTop = 0;

            // Scroll to Bottom
            setTimeout(() => {
                this.$refs.refContentBody.scrollTop = this.$refs.refContentBody.scrollHeight;
            }, 0);
        }
    }
}
</script>